import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import type { DialogColor, DialogWidth, SlotOrientation } from './types';

export const getContentCss = ({
  color,
  width,
  slotOrientation,
}: {
  color: DialogColor;
  width: DialogWidth;
  slotOrientation?: SlotOrientation;
}) => {
  const isSmall = width === 'small';
  const spacing = isSmall ? 'var(--cds-spacing-200)' : 'var(--cds-spacing-300)';
  // Add top padding for colored backgrounds (provides visual separation from heading)
  // Skip when slot is present since heading already has visual separation from slot
  const paddingTop = color !== 'white' && !slotOrientation ? spacing : 0;

  return css`
    grid-area: content;
    padding: ${paddingTop} ${spacing} 0 ${spacing};

    ${breakpoints.down('xs')} {
      padding-right: var(--cds-spacing-200);
      padding-left: var(--cds-spacing-200);
    }
  `;
};
